const zzzfunStats = [
  { value: '20000+', label: '番剧资源总量' },
  { value: '4', label: '全平台客户端' },
  { value: '1080P+', label: '高清画质支持' },
  { value: '99.9%', label: '播放流畅率' },
];

export default function ZzzfunStats() {
  return (
    <section id="zzzfun-stats" className="scroll-mt-24 bg-primary-500 py-16 md:py-20">
      <div className="mx-auto w-full px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <h2 className="font-heading text-3xl text-background-50 dark:text-foreground-950 md:text-4xl">
            用数据说话
          </h2>
          <p className="mt-4 text-sm text-background-50/90 dark:text-foreground-950/80 md:text-base">
            ZzzFun持续为动漫爱好者提供稳定、丰富、流畅的观看服务。
          </p>
        </div>

        <div className="mt-12 grid grid-cols-2 gap-6 lg:grid-cols-4">
          {zzzfunStats.map((stat) => (
            <div key={stat.label} className="text-center">
              <p className="font-display text-4xl font-bold text-background-50 dark:text-foreground-950 md:text-5xl">
                {stat.value}
              </p>
              <p className="mt-2 text-xs text-background-50/90 dark:text-foreground-950/80 md:text-sm">
                {stat.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}